import { Spin } from 'antd';
import React, { Suspense } from 'react';

export default function wrapDialog(element,spinning=true){
          return (
            <Suspense fallback={<div className="suspense-container"><Spin spinning={spinning} size="large" wrapperClassName='in-center suspense-loading'></Spin></div>} >
                {element}
            </Suspense>
          );
}